import axiosClient from './axiosClient';

/** Endpoints for the authenticated TECHNICIAN role (/api/v1/technician/**). */
const technicianService = {
  getProfile: () => axiosClient.get('/technician/profile'),
  updateProfile: (payload) => axiosClient.put('/technician/profile', payload),
  setAvailability: (availableForWork) =>
    axiosClient.put('/technician/availability', { availableForWork }),
  uploadCertification: (file) => {
    const form = new FormData();
    form.append('file', file, file.name);
    return axiosClient.post('/technician/certifications', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getDashboard: () => axiosClient.get('/technician/dashboard'),

  // Bookings
  listBookings: (params = {}) => axiosClient.get('/technician/bookings', { params }),
  getBooking: (id) => axiosClient.get(`/technician/bookings/${id}`),
  updateBookingStatus: (id, status, extra = {}) =>
    axiosClient.patch(`/technician/bookings/${id}/status`, { status, ...extra }),

  // Reviews
  listReviews: (params = {}) => axiosClient.get('/technician/reviews', { params }),
  replyToReview: (id, response) =>
    axiosClient.post(`/technician/reviews/${id}/reply`, { response }),
};

export default technicianService;
